﻿import { GuiDetailGeneric } from "../../GuiDetailGeneric";
export class GuiDetailBestellungAktionKostenverteilung extends GuiDetailGeneric {
    constructor() {
        super("GuiDetailBestellungAktionKostenverteilung");
    }
}
